"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerDomainCardClick = exports.getSimpleDomainTemplate = void 0;
const lit_html_1 = require("lit-html");
const _button_1 = require("./_button");
const achievements_1 = require("./achievements");
/**
 * Возвращает шаблон домена
 */
function getSimpleDomainTemplate(domain, translations) {
    let wrapperClass = 'domain domain-simple domain--hoverable';
    return (0, lit_html_1.html) `
        <div class="${wrapperClass}">
            ${getSimpleInnerDomainTemplate(domain, translations)}
        </div>
    `;
}
exports.getSimpleDomainTemplate = getSimpleDomainTemplate;
/**
 * Возвращает внутренний шаблон домена
 */
function getSimpleInnerDomainTemplate(domain, translations) {
    return (0, lit_html_1.html) `
            <div class="domain__wrapper js-domain-ga">
                ${domain.premium ? (0, lit_html_1.html) `
                    <a class="domain__name" href="/${translations.getLanguagePrefix()}/domain/${domain.name}">
                        <span>${domain.name}</span>.<span>${domain.zone}</span>
                    </a>
                ` : (0, lit_html_1.html) `<span class="domain__name">
                        <span>${domain.name}</span>.<span>${domain.zone}</span>
                    </span>`}
                <span class="flex">
                    <span class="domain__primary">
                        ${domain.premium ? (0, lit_html_1.html) `
                            <span class="domain__prefix">
                                <span class="domain__icon"></span>
                                ${translations.instant('premium')}
                            </span>
                        ` : null}
                    </span>
                    ${domain.advantages && domain.advantages.length > 0 ? (0, lit_html_1.html) `
                        <span class="domain__link_advantages text-right">
                            <span class="link">${translations.instant('domainAdvantagesLink')}</span>
                        </span>
                    ` : null}
                </span>
                <div class="domain__tertiary">
                    <div class="domain__price">
                        ${!domain.taken && !domain.request ? (0, lit_html_1.html) `
                            <div class="domain__price__amount">
                                $ ${Intl.NumberFormat('en', { minimumFractionDigits: 0 }).format(domain.price)}
                            </div>
                        ` : null}
                        ${!domain.taken && !domain.request ? (0, lit_html_1.html) `
                            <div class="domain__price__rent">
                                $ ${[Intl.NumberFormat('en', { minimumFractionDigits: 0 }).format(domain.renew), translations.instant('year')].join(' / ')}
                            </div>
                        ` : null}
                    </div>
                    <span class="domain__actions${domain.bought ? ' soldout' : ''}${domain.request ? ' request' : ''}${domain.inCart ? ' incart' : ''}">
                        ${(0, _button_1.getButtonTemplate)(domain, _button_1.ButtonTemplateStyle.TRANSPARENT, translations)}
                    </span>
                </div>
                ${(0, achievements_1.getDomainAdvantagesTemplate)(domain.advantages, translations, `/${translations.getLanguagePrefix()}/domain/${domain.name}`)}
            </div>
    `;
}
/**
* Отслеживание клика по карточке домена
*/
function registerDomainCardClick() {
    const searchResultWrapper = document.querySelector('.domain-simple') ? document.querySelector('.domain-simple').parentElement : null;
    if (searchResultWrapper) {
        searchResultWrapper.addEventListener('click', (e) => {
            const el = e.target;
            if (el.closest('.domain__advantages .btn-close')) {
                e.preventDefault();
                el.closest('.domain__advantages').classList.remove('active');
            }
            if (el.closest('.domain__link_advantages .link')) {
                e.preventDefault();
                el.closest('.domain').querySelector('.domain__advantages').classList.add('active');
            }
        });
    }
    const domainCards = document.querySelectorAll('.domain-simple');
    if (domainCards) {
        domainCards.forEach((item) => {
            if (item.querySelector('.domain__advantages') && item.querySelector('.domain__advantages_list ul').getBoundingClientRect().height > item.querySelector('.domain__advantages_list').getBoundingClientRect().height) {
                item.querySelector('.domain__advantages .js-read-more').classList.remove('hidden');
            }
        });
    }
}
exports.registerDomainCardClick = registerDomainCardClick;
